<template>
  <div class="coupon-list-popup">
    <div class="coupon-list-popup-shade"></div>
    <div class="coupon-list-popup-content">
      <p class="coupon-list-popup-title">
        {{ letter.quanGift }}
      </p>
      <div class="coupon-list-popup-content-scroll">
        <p class="coupon-list-tip">{{ letter.quanGiftTips }}</p>
        <template v-if="couponList.length">
          <coupon-item
            v-for="item in couponList"
            :key="item.COUPON_ID"
            :info="item"
            :active="false"
            :showItemUseBtn="showItemUseBtn"
            @closePopup="hidePopup"
          ></coupon-item>
        </template>
      </div>
      <a
        class="coupon-list-popup-close j-click-coupon-close"
        href="javascript:;"
        @click="hidePopup"
      ></a>
    </div>
  </div>
</template>

<script>
import CouponItem from '@components/officialStore/coupon/CouponItem.vue';

export default {
  name: 'CouponBirthPopup',
  props: {
    couponList: {
      default: []
    },
    showItemUseBtn: {
      default: true
    }
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  methods: {
    hidePopup() {
      this.$emit('closeCouponPopup');
    }
  },
  components: {
    CouponItem
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.coupon-list-popup {
  position: fixed;
  left: 0;
  top: 0;
  // 层级高过CouponVipPopup.vue组件，优先弹出该生日弹
  z-index: 1002;
  width: 100%;
  height: 100%;
  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    padding: 37px 47px;
    width: 691px;
    height: 90%;
    background-size: 100% 100%;
    transform: translate(-50%, -50%);
    @psetbg ('coupon-popup-bg.png', false, false);
    &-scroll {
      overflow: -moz-scrollbars-none;
      overflow-y: scroll;
      position: relative;
      max-height: 90%;

      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
      }
      .coupon-list-tip {
        margin-bottom: 20px;
        text-align: left;
        font-size: 20px;
        color: var(--coupon-popup-list-tip);
      }
    }
  }
  &-title {
    margin-bottom: 39px;
    text-align: center;
    font-size: 48px;
    color: var(--coupon-popup-title);
  }
  &-tip {
    font-size: 20px;
    color: var(--coupon-popup-tip);
  }
  &-close {
    position: absolute;
    right: 31px;
    top: 30px;
    background-size: cover;
    cursor: pointer;
    @psetbg ('close.png');
  }
}
@media screen and (orientation: landscape) {
  .coupon-list-popup {
    &-content {
      padding: 25px 32px;
      width: 444px;
      height: 90%;
      background-size: 100% 100%;
    }
    &-title {
      font-size: 30px;
    }
    &-close {
      // 这里
      position: absolute;
      @psetbg ('close.png');
      width: 28px !important;
      height: 28px !important;
    }
  }
}
</style>
